import { createSelector } from 'reselect';

export const selectedProvision = (state: any) => {
  return state.get('provisionRegulation');
};

const makeSelectSagisClaim = () =>
  createSelector(selectedProvision, claim => {
    if (claim && claim.get('sagisClaim')) {
      const selectedClaim = claim.get('sagisClaim').toJS();
      return selectedClaim;
    }
    return {};
  });
const makeSelectJudgementOnMeritsByVictims = () =>
  createSelector(selectedProvision, judgement => {
    if (judgement && judgement.get('judgementOnMeritsByVictims')) {
      return judgement.get('judgementOnMeritsByVictims').toJS();
    }
    return [];
  });

const makeSelectJudgementOnMeritsByVehicles = () =>
  createSelector(selectedProvision, judgement => {
    if (judgement && judgement.get('judgementOnMeritsByVehicles')) {
      return judgement.get('judgementOnMeritsByVehicles').toJS();
    }
    return [];
  });
const makeSelectEncryptedDocuments = () =>
  createSelector(selectedProvision, judgement => {
    if (judgement && judgement.get('corporealEncryptedDocuments')) {
      return judgement.get('corporealEncryptedDocuments').toJS();
    }
    return [];
  });
const makeSelectMaterialEncryptedDocuments = () =>
  createSelector(selectedProvision, judgement => {
    if (judgement && judgement.get('materialEncryptedDocuments')) {
      return judgement.get('materialEncryptedDocuments').toJS();
    }
    return [];
  });
const makeSelectAssignedLawyers = () =>
  createSelector(selectedProvision, judgement => {
    if (judgement && judgement.get('assignedLawyers')) {
      return judgement.get('assignedLawyers').toJS();
    }
    return [];
  });
const makeRegulations = () =>
  createSelector(selectedProvision, judgement => {
    if (judgement && judgement.get('regulations')) {
      return judgement.get('regulations').toJS();
    }
    return [];
  });
const makeCreatedRegulations = () =>
  createSelector(selectedProvision, judgement => {
    if (judgement && judgement.get('createdRegulations')) {
      return judgement.get('createdRegulations').toJS();
    }
    return [];
  });
const makeSelectRegulation = () =>
  createSelector(selectedProvision, judgement => {
    if (judgement && judgement.get('currentRegulation')) {
      return judgement.get('currentRegulation').toJS();
    }
    return {};
  });
export {
  makeSelectSagisClaim,
  makeSelectJudgementOnMeritsByVictims,
  makeSelectJudgementOnMeritsByVehicles,
  makeSelectEncryptedDocuments,
  makeSelectMaterialEncryptedDocuments,
  makeSelectAssignedLawyers,
  makeRegulations,
  makeCreatedRegulations,
  makeSelectRegulation,
};
